import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Footer = () => {
  return (
    <div style={{backgroundColor:'#e9ddbd', padding:'60px', color:'whitesmoke'}}>
      <Container>
        <Row>
          <Col style={{textAlign:'center'}}>
            <img src='https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/logo-colectivo.jpg' alt='Colectivo por más participación' width={200} />
          </Col>
          <Col style={{textAlign:'center'}}>
            <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Presupuesto-Participativo02.png" 
            width="300px" 
            alt="Presupuesto Participativo" />
          </Col>
          <Col style={{textAlign:'center'}}>
          <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Presupuesto-Participativo-Joven01.png" 
            width="300px" 
            alt="PP Joven" />            
          </Col>
          <Col style={{textAlign:'center'}}>
          <img src='https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/marcamuni.png' alt='Municipalidad de Trenque Lauquen' style={{marginTop:'20px'}} />
          </Col>          
        </Row>
      </Container>
    </div>
  )
}

export default Footer